import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedMainHubPriorityMedias from './viewRelatedMainHubPriorityMedias';

export default {
  title: 'Spaces Feature',
  attributeName: 'spacesEnabled',
  fields: [
    {
      attributeName: 'spacesEnabled',
      label: 'Spaces Gallery Enabled',
      type: FormInputTypes.CHECKBOX,
      helpText: 'Enable or disable Spaces gallery of the App for this config.',
      default: true,
    },
    {
      attributeName: 'spacesGalleryTopBanner',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Spaces Gallery Top Banner 1696x612 or 928x334  (928x334 only androidXR)',
      helpText: 'Any valid url to a PNG top banner image file to use inside the spaces element.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
      // visibleWhen:[{"field":"spacesEnabled","value":true}],
      allowedSizes: [
        { width: 1696, height: 612 },
        { width: 928, height: 334 }
      ],
    },
  ],
};